module.exports = __webpack_public_path__ + "img/people02.fcb66558.png";